import React from "react"
import { useState, useCallback, useContext } from "react"
import DodoneContext from 'app/dodones/Context'

export default ({ text = "Start" }) => {
  const { startDodone } = useContext(DodoneContext);
  const [isConfirmed, setIsConfimed] = useState(false);

  const onStart = useCallback(() => {
    if(!isConfirmed) {
      setIsConfimed(true);
      return;
    }

    startDodone();
  })

  return <div className="input-group">
           <button className="btn btn-primary btn-block" onClick={ onStart }>
             {
               isConfirmed ? 'Start?' : text
             }
           </button>
         </div>
}
